import React, { useEffect } from 'react';

import Slider from './Slider/Slider';
import image1 from '../../assets/1.png';
import image2 from '../../assets/2.png';
import image3 from '../../assets/3.png';
import logo from '../../assets/logo.svg';

import { useInView } from 'react-intersection-observer';

const Hero = ({ setCurrentMenu }) => {
  const { ref, inView } = useInView({
    threshold: 0.8
  });

  const random = [
    image1,
    image2,
    image3
  ];

  useEffect(() => {
    if (inView) {
      setCurrentMenu(0)
    }
  }, [inView, setCurrentMenu])

  return (
    <header className="relative pt-16 w-full" ref={ref}>
      <Slider imageList={random} />
      <div className="relative -top-20 bg-transparent flex justify-center items-center md:absolute md:top-0 md:right-0 md:bottom-0 md:left-0">
        <div className="shadow-md max-w-sm mx-4 md:mx-0 md:max-w-md p-10 rounded-md bg-white/60 md:bg-slate-900/30 backdrop-blur-sm flex flex-col items-center">
          <img src={logo} alt="Logo" className="w-full md:h-full" />
          <div className="mt-8 text-center text-slate-700 md:text-white">
            <h3 className="text-3xl font-semibold tracking-widest">We are Cotechca</h3>
            <p className="font-light tracking-widest">Product Designer and Developer</p>
          </div>
          <div className="mt-10 text-center text-slate-700 md:text-white">
            <p className="font-light tracking-widest">Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci, atque!</p>
          </div>
          <div className="mt-6 text-center">
            <a className="text-main font-semibold tracking-widest" href="#">Check Our Services</a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
